import { render, staticRenderFns } from "./showBigImg.vue?vue&type=template&id=b419b1e6"
import script from "./showBigImg.vue?vue&type=script&lang=js"
export * from "./showBigImg.vue?vue&type=script&lang=js"
import style0 from "./showBigImg.vue?vue&type=style&index=0&id=b419b1e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports